import { gql } from '@apollo/client';

export const RESEND_CREDENTIALS_TO_ADMINISTRATOR = gql`
  mutation ResendCredentialsToAdministrator($input: ResendCredentialsToAdministratorInput!) {
    resendCredentialsToAdministrator(input: $input) {
      administratorId
    }
  }
`;
